import React from 'react';
import Button from 'src/components/10-atoms/button/Button';
import ListItemLayout from 'src/components/10-atoms/content/list-item/ListItemLayout';
import FeatherIcon from 'src/components/10-atoms/icons/FeatherIcon';
import IllustrationImage from 'src/components/10-atoms/image/IllustrationImage';
import Column from 'src/components/10-atoms/layout/Column';
import Row from 'src/components/10-atoms/layout/Row';
import Typography from 'src/components/10-atoms/typography/Typography';
import BottomDrawerLayout from 'src/components/20-helper-views/bottom-drawer/BottomDrawerLayout';
import AppAssets from 'src/constants/appAssets';
import { TypographyVariant } from 'src/customizations/themes/10-parts/typography';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import createThemedStyle from 'src/customizations/themes/utils/createThemedStyles';
const Img2TxtIntroDrawer = ({ onConfirm }) => {
    const [{ theme }] = useTheme(stylesGenerator);
    return (React.createElement(BottomDrawerLayout, null,
        React.createElement(BottomDrawerLayout.Title, null, "Click to Answer"),
        React.createElement(BottomDrawerLayout.ScrollableBody, null,
            React.createElement(IllustrationImage, { source: { uri: AppAssets.img2TxtIllustration } }),
            React.createElement(Column, { mt: theme.spacing.standard.lg },
                React.createElement(Row, { xAxis: "center", pv: theme.spacing.standard.md },
                    React.createElement(Typography, { align: "center", variant: TypographyVariant.PAGE_TITLE }, "Why type, when you can just click \uD83C\uDF89\uD83C\uDF89\uD83C\uDF89")),
                React.createElement(Column, { spacing: theme.spacing.standard.sm },
                    React.createElement(ListItemLayout.Icon, { Icon: React.createElement(FeatherIcon, { name: "image" }) }, "Click the image of the Answer (Handwritten or Typed)"),
                    React.createElement(ListItemLayout.Icon, { Icon: React.createElement(FeatherIcon, { name: "gift" }) }, "Wait for magic to happen..."),
                    React.createElement(ListItemLayout.Icon, { Icon: React.createElement(FeatherIcon, { name: "edit-2" }) }, "Verify the text and edit as needed"),
                    React.createElement(ListItemLayout.Icon, { Icon: React.createElement(FeatherIcon, { name: "send" }) }, "Submit the answer")))),
        React.createElement(BottomDrawerLayout.Actions, null,
            React.createElement(Button, { flex: true, onPress: onConfirm }, "Awesome, got it!"))));
};
const stylesGenerator = createThemedStyle(({}) => ({}));
export default Img2TxtIntroDrawer;
